import { useContext } from 'react';
import SuccessMessageContext, { SuccessMessageContextType } from '../context/SuccessMessageContext';

export default (): SuccessMessageContextType => useContext(SuccessMessageContext);
